







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import EBilling from '@/components/e-billing/e-billing.vue';

@Component({
  components: {
    EBilling,
    PageTitle
  }
})
export default class EBillingView extends Vue {}
